import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useLocation } from 'react-router-dom';

import { PasswordRecover } from './recover';
import { PasswordNew } from './new';

import PasswordIlustration from './../../assets/images/placeholder/Password-illustration.svg';

export const PasswordIndex = () => {
    const location = useLocation();
    return (
        <main role="main" className="view flex-grow-1 pb-sm pb-xl-gutter" style={{ minHeight: "500px" }}>
            <div className="container-fluid container-modal m-auto h-inherit">
                <section className="card card-body card-lg rounded-top-left-xl rounded-bottom-right-xl h-inherit" >
                    <h4 className="sr-only visually-hidden">Reset Compte</h4>
                    <div className="row justify-content-row gx-2 h-inherit">
                        <div className="col-12 col-lg h-inherit">
                            <img className="img-fluid img-contain container-md-wide mx-auto mt-4 my-lg-auto h-inherit" width="480" src={PasswordIlustration} alt="Assist@" />
                        </div>
                        <Switch>
                            <Route path="/auth/password/recover" component={PasswordRecover} />
                            <Route path="/auth/password/new" component={PasswordNew} />

                            <Route render={() => {
                                return <Redirect to={`/auth/password/recover${location.search}`} />;
                            }} />
                        </Switch>
                    </div>
                </section>
            </div>
        </main>
    );

};